// extracted by mini-css-extract-plugin
export default {"content":"d5eiX","content__description":"kkV8x"};